import { getLocationByCustomerRef as getLocationByCustomerRefOp } from '@gql/operations'
import { type GqlExecutor } from '@hopdrive/sdk-core'
import type { Location } from '../../types'

export interface FindByCustomerRefParams {
  customerId: number
  customerRef: string
  executor?: GqlExecutor
}

/**
 * Find location by customer-defined reference.
 */
export async function findLocationByCustomerRef(params: FindByCustomerRefParams): Promise<Location | null> {
  const locations = await getLocationByCustomerRefOp(
    { customerId: params.customerId, customerRef: params.customerRef },
    { executor: params.executor }
  )

  return (locations?.[0] as Location) ?? null
}
